import {
  Card,
  Col, Container, Row, Tab, TabContainer, Tabs,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import useEditorParams from '../../../newEditor/hook/params';
import useEditor from '../../../newEditor/hook/editor';
import EditorContainer from '../../../newEditor/editorContainer';
import { CatCommandPanel } from '../../../newEditor/commandPanels';
import { EditorControls, editorHooks } from '../../../basicEditor/editorControls';
import meta from '../../../../meta';

const { backendURL } = meta.cat.inspection;

function Editor({
  onSave, onClose, id,
}) {
  const editorParams = useEditorParams();
  const {
    data, actions, fields, fieldErrors, nonFieldErrors, options, isNew, changed, permissions,
    loading, systemErrors, headerReadOnlyFields, printForms,
  } = useEditor({
    backendURL,
    id,
    onCloseCallBack: onClose,
    onSaveCallBack: onSave,
    ...editorParams,
  });

  const fullnameProps = editorHooks.useStringInputProps('fullname', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const nameProps = editorHooks.useStringInputProps('name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const smtpPort = editorHooks.useNumberInputProps('smtp_port', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const smtpServer = editorHooks.useStringInputProps('smtp_server', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const emailProps = editorHooks.useStringInputProps('email', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const passEmail = editorHooks.useStringInputProps('pass_email', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const subjectGrm = editorHooks.useStringInputProps('subject_grm', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const bodyGrm = editorHooks.useStringInputProps('body_grm', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const subjectClient = editorHooks.useStringInputProps('subject_client', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const bodyClient = editorHooks.useStringInputProps('body_client', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const emailForAktProps = editorHooks.useStringInputProps('email_for_akt', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const addressProps = editorHooks.useStringInputProps('address', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const phoneNumberProps = editorHooks.useStringInputProps('phone_number', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const edrpouProps = editorHooks.useStringInputProps('edrpou', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const postCodeProps = editorHooks.useStringInputProps('post_code', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const skypeProps = editorHooks.useStringInputProps('skype', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const webSiteProps = editorHooks.useStringInputProps('web_site', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const conclusion = editorHooks.useTextInputProps('conclusion', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const deletedProps = editorHooks.useCheckboxInputProps('deleted', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const loginTypeProps = editorHooks.useSelectorInputProps('login_type', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  return (
    <EditorContainer
      isNew={isNew}
      name={options.name}
      repr={data.repr}
      isLoading={loading}
      err={systemErrors}
      nonFieldErrors={nonFieldErrors}
      onClearNonFieldErrors={actions.onClearNonFieldErrors}
      onClearErrors={actions.onClearErrs}
      onClose={actions.onClose}
      changed={changed}
      fields={fields}
      CommandPanel={(
        <CatCommandPanel
          backendURL={backendURL}
          permissions={permissions}
          actions={actions}
          changed={changed}
          executed={data.executed}
          printForms={printForms}
          id={id}
          repr={data.repr}
        />
      )}
    >
      <Tabs defaultActiveKey="general" id="uncontrolled-tab-inspection">
        <Tab eventKey="general" title="Основні властивості">
          <TabContainer>
            <Container fluid>
              <Row>
                <Col>
                  <EditorControls.StringInput {...nameProps} />
                </Col>
                <Col>
                  <EditorControls.StringInput {...edrpouProps} />
                </Col>
                <Col>
                  <EditorControls.StringInput {...phoneNumberProps} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <EditorControls.StringInput {...fullnameProps} />
                </Col>

                <Col>
                  <EditorControls.StringInput {...skypeProps} />
                </Col>

              </Row>
              <Row>
                <Col lg={2} mg={2}>
                  <EditorControls.StringInput {...postCodeProps} />
                </Col>
                <Col>
                  <EditorControls.StringInput {...addressProps} />
                </Col>

                <Col lg={3} mg={3}>
                  <EditorControls.StringInput {...webSiteProps} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <EditorControls.TextInput
                    {...conclusion}
                    rows={3}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <EditorControls.SelectorInput {...loginTypeProps} />
                </Col>
                <Col className="mt-2">
                  <EditorControls.CheckboxInput {...deletedProps} />
                </Col>
              </Row>
            </Container>
          </TabContainer>
        </Tab>
        <Tab eventKey="emailSettings" title="Налаштування пошти">
          <TabContainer>
            <Container fluid>
              <Row className="my-3">
                <Col>
                  <Card className="border-0 p-3">
                    <Card.Title>
                      Налаштування пошти організації
                    </Card.Title>
                    <Card.Body className="p-1">
                      <Row>
                        <Col>
                          <EditorControls.StringInput {...emailProps} />
                        </Col>
                        <Col>
                          <EditorControls.StringInput {...passEmail} type="password" />
                        </Col>
                        <Col>

                          <EditorControls.StringInput {...smtpServer} />
                        </Col>
                        <Col>

                          <EditorControls.NumberInput {...smtpPort} />
                        </Col>

                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Card className="border-0 p-3">
                    <Card.Title>
                      Налаштування відправки пошти до ГРМ
                    </Card.Title>
                    <Card.Body className="p-1">
                      <EditorControls.StringInput {...emailForAktProps} />
                      <EditorControls.StringInput {...subjectGrm} />
                      <EditorControls.TextInput {...bodyGrm} rows={15} />
                    </Card.Body>
                  </Card>
                </Col>

                <Col>
                  <Card className="border-0 p-3">
                    <Card.Title>
                      Налаштування відправки пошти до замовника
                    </Card.Title>
                    <Card.Body className="p-1">
                      <EditorControls.StringInput {...subjectClient} />
                      <EditorControls.TextInput {...bodyClient} rows={15} />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </TabContainer>
        </Tab>
      </Tabs>

    </EditorContainer>
  );
}

Editor.propTypes = {
  id: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

Editor.defaultProps = {
  onClose: null,
  onSave: null,
};

export default Editor;
